import { podcastFoldActions } from './actions-const';

export function openFold(podcast, collectionId) {
  return (dispatch) => {
    dispatch({
      type: podcastFoldActions.OPEN_FOLD,
      podcast,
      collectionId,
    });
  };
}

export function closeFold() {
  return (dispatch) => {
    dispatch({
      type: podcastFoldActions.CLOSE_FOLD,
    });
  };
}
